import { v4 as uuid } from 'uuid';

import type { EppStaticOption } from './reducer';

export function staticOption(value = '', displayText: undefined | string = undefined): EppStaticOption {
    return { id: uuid(), value, displayText };
}
